module.exports = __webpack_public_path__ + "assets/google-plus-icon-32.png?bfc72fc8ceb394ddac3fd01e695022b8";